import { __rest } from "tslib";
import { Radio as $Radio } from 'antd';
import * as React from 'react';
import Field from '../field';
export var Radio = function Radio(_a) {
  var name = _a.name,
      validate = _a.validate,
      fast = _a.fast,
      _onChange = _a.onChange,
      restProps = __rest(_a, ["name", "validate", "fast", "onChange"]);

  return React.createElement(Field, {
    name: name,
    validate: validate,
    fast: fast
  }, function (_ref) {
    var value = _ref.field.value,
        _ref$form = _ref.form,
        setFieldValue = _ref$form.setFieldValue,
        setFieldTouched = _ref$form.setFieldTouched;
    return React.createElement($Radio, Object.assign({
      value: value,
      onChange: function onChange(event) {
        setFieldValue(name, event.target.value);
        setFieldTouched(name, true, false);
        _onChange && _onChange(event);
      }
    }, restProps));
  });
};
export default Radio;

Radio.Group = function (_a) {
  var name = _a.name,
      validate = _a.validate,
      fast = _a.fast,
      _onChange2 = _a.onChange,
      restProps = __rest(_a, ["name", "validate", "fast", "onChange"]);

  return React.createElement(Field, {
    name: name,
    validate: validate,
    fast: fast
  }, function (_ref2) {
    var value = _ref2.field.value,
        _ref2$form = _ref2.form,
        setFieldValue = _ref2$form.setFieldValue,
        setFieldTouched = _ref2$form.setFieldTouched;
    return React.createElement($Radio.Group, Object.assign({
      value: value,
      onChange: function onChange(event) {
        setFieldValue(name, event.target.value);
        setFieldTouched(name, true, false);
        _onChange2 && _onChange2(event);
      }
    }, restProps));
  });
};

Radio.Button = $Radio.Button;